module.exports = __webpack_public_path__ + "img/phone.0c032915.svg";